import CustomerUptimeListResourceModel from '../../generated/types/model/resource/CustomerUptimeListResourceModel';

export default class CustomerUptimeListResourceViewModel extends CustomerUptimeListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
